module.exports = __webpack_public_path__ + "static/media/close-fill.66b2e306.svg";